	
	import { app } from '../globals/objects'
	import { constants } from '../globals/constants'

	const MainMenu = () => {
		
		
		var $navbar_toggle       = $('.navbar-toggle'),  
			$main_navbar         = $('.header-navbar'),
			$main_navbar_classic = $('.header-navbar-classic'),
			$menu_toggle         = $('.menu-toggle'),
			$menu_link           = $('.menu-link'),
			_main_menu           = '.header-menu',
			_menu_drop           = '.menu-drop',
			_open_nav            = 'open-nav',
			_nav_overlay         = '.header-navbar-overlay',
			_open_menu           = 'menu-shown',
			_active_nav          = 'navbar-active';
		
		var MenuInit = {};
        
		// navToggle @v1.0
		MenuInit.Overlay = function () {
			if($main_navbar.exists() ){
                $main_navbar.append('<div class="header-navbar-overlay"></div>');
            }
        };
		MenuInit.navToggle = function () {
			if($navbar_toggle.exists() ){
				$navbar_toggle.on('click', function(e){
                    var $self = $(this), _self_toggle = ($self.data('menu-toggle'));
                        $self.toggleClass(_active_nav);
                    if($main_navbar_classic.exists()) {
                       $('#' + _self_toggle).slideToggle().toggleClass(_open_menu);
                    }else{
                       $('#' + _self_toggle).parent().toggleClass(_open_menu);
                    }
					e.preventDefault();
				});
			}
		};
		// navClose @v1.0
		MenuInit.navClose = function () {
            $(_nav_overlay).on('click', function(){
                $navbar_toggle.removeClass(_active_nav);
                $main_navbar.removeClass(_open_menu);
            });
            $menu_link.on('click', function(e){
                if(!$(this).hasClass('menu-toggle')){
                    $navbar_toggle.removeClass(_active_nav);
                    $main_navbar.removeClass(_open_menu);
                }
            })
			app.$doc.on('click', 'body', function(e){
				if (!$menu_toggle.is(e.target) && $menu_toggle.has(e.target).length===0 && !app.$header.is(e.target) && app.$header.has(e.target).length===0 && app.$win.width() < constants._navBreak)  {
					$navbar_toggle.removeClass(_active_nav);
					$main_navbar_classic.find(_main_menu).slideUp();
                    $main_navbar.removeClass(_open_menu);
				}
			});
		};
        
		// menuToggle @v1.0
		MenuInit.menuToggle = function () {
			if ($menu_toggle.exists()) {
				$menu_toggle.on("click",function(e){
					var $parent = $(this).parent();
					if (app.$win.width() < constants._navBreak) {
						$parent.children(_menu_drop).slideToggle(400);
						$parent.siblings().children(_menu_drop).slideUp(400);
						$parent.toggleClass(_open_nav);
						$parent.siblings().removeClass(_open_nav);
					}
					e.preventDefault();
				});
			}
		};
		// mobileNav @v1.0
		MenuInit.mobileNav = function() {
			if(app.$win.width() < constants._navBreak){
				$main_navbar.delay(500).addClass(constants._mobMenu);
			}else{
				$main_navbar.delay(500).removeClass(constants._mobMenu);
				$main_navbar.removeClass(_open_menu);
			}
		};
		// currentPage @v1.0
		MenuInit.currentPage = function() {
			if ($menu_link.exists()) {
				$menu_link.each(function() {
					if (constants._currentURL === (this.href) && (constants._splitURL[1]!=="")) {
						$(this).closest("li").addClass("active").parent().closest("li").addClass("active");
					}
				});
			}
		};
		// Initialing
		MenuInit.Overlay(); MenuInit.navToggle(); MenuInit.navClose(); 
        MenuInit.menuToggle(); MenuInit.mobileNav(); MenuInit.currentPage();
        app.$win.on('resize', function(){
            MenuInit.mobileNav();
        });
	};

	const MenuDown = () => {

		const $btn = $('.menu-down-btn');
		const $body = $('body');
		const _toggleClass = 'menu-down';

		$btn.on('click', () => {
			$body.toggleClass(_toggleClass)
		});

	}

	export { MainMenu, MenuDown }